module.exports = __webpack_public_path__ + "static/media/gif3.a24ced13.gif";